import styled from "styled-components";

import {getTheme} from "../../shared/themeUtils";

const BreadcrumbsContain = styled.div`
  margin-bottom: ${getTheme("space.2")};
`

type BreadcrumbsPlaceholderProps = {
  className?: string
}

const BreadcrumbsPlaceholder = (props: BreadcrumbsPlaceholderProps) => {
  return (
    <BreadcrumbsContain className={props.className}>
      <p className="card-text placeholder-wave">
        <span className="placeholder col-8"></span>
      </p>
    </BreadcrumbsContain>
  )
}

export default BreadcrumbsPlaceholder
